import type { RootThunkDispatch } from 'store'
import { START_FETCH, FETCHED } from './actionTypes'
import * as contentApi from 'services/content'

export function fetchMenus() {
  return (dispatch: RootThunkDispatch, getState) => {
    const { needsFetched } = getState().menus

    if (!needsFetched) {
      return Promise.resolve()
    }

    dispatch({
      type: START_FETCH,
    })

    return contentApi.fetchSiteOptions().then((response) => {
      dispatch({
        type: FETCHED,
        payload: response,
      })
    })
  }
}
